module.exports = __webpack_public_path__ + "static/media/nyt-logo.0a43b98b.png";